"use strict";

module.exports = function(angular, moduleName) {
  angular
    .module(moduleName)
    .service("componentRepository", require("app/business/componentRepository"))
    .service("cookieRepository", require("app/business/cookieRepository"))
    .service("cookieService", require("app/business/cookieService"))
    .service("eikonSessionMonitor", require("app/business/eikonSessionMonitor"))
    .service(
      "openFinWebAuthenticator",
      require("app/business/openFinWebAuthenticator")
    )
    .service(
      "openFinWebClientInitializer",
      require("app/business/openFinWebClientInitializer")
    )
    .service(
      "rediPlusWorkspaceService",
      require("app/business/rediPlusWorkspaceService")
    )
    .service(
      "rediPlusLifeCycleManager",
      require("app/business/rediPlusLifeCycleManager")
    )
    .service(
      "sideBySideInitializer",
      require("app/business/sideBySideInitializer")
    )
    .service(
      "rediPlusWindowService",
      require("app/business/rediPlusWindowService")
    );
};



// WEBPACK FOOTER //
// ./app/business/businessIndex.js